import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import ReactTable from "./../../../../components/FilterTable";
import { _HttpServices } from "./../../../../_services/_HttpServices";
import Loader from "./../../../../components/Loader";
import moment from "moment";
import { Footer } from "../../../../components/Footer";

const TrackTrance = () => {
  const fileName = "TrackTrance";
  const [trackTrace, setTrackTrace] = useState([]);
  const [loading, setLoading] = useState(false);
  const columns = [
    // {
    //   Header: "Auto Approve",
    //   accessor: "AutoApproval",
    //   sortType: "basic",
    //   disableFilters: true,
    //   width: 90,
    //   Cell: (rowInfo) => {
    //     return (
    //       <input
    //         className="checkbox"
    //         type="checkbox"
    //         checked={rowInfo.row.original.AutoApproval === true}
    //         onClick={(e) => clickOnCheckBox(e, rowInfo.row.original)}
    //       ></input>
    //     );
    //   },
    // },
    {
      Header: "Contact ID",
      accessor: "CustomerNumberAccountID",
      filter: "CustomerNumberAccountID",
      sortType: "basic",
      width: 100,
    },
    {
      Header: "Contact Name ",
      accessor: "EntityName",
      filter: "EntityName",
      sortType: "basic",
      width: 500,
    },
    {
      Header: "Email ID",
      accessor: "Email",
      filter: "Email",
      sortType: "basic",
      width: 300,
    }
  ];
  const clickOnCheckBox = async (e, row) => {
    setLoading(true);
    let autoApproval = e.target.checked;
    let customerNumberAccountID = row.CustomerNumberAccountID;
    await _HttpServices
      .getData(
        `Api/Inbound/GetUpdateTrackContacts?CustomerNumberAccountID=` +
          customerNumberAccountID +
          `&AutoApproval=` +
          autoApproval
      )
      .then((response) => {
        if (response.data) {
          getContactTrackTrace();
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };
  useEffect(() => {
    getContactTrackTrace();
  }, []);
  async function getContactTrackTrace() {
    setLoading(true);
    await _HttpServices
      .getData("Api/Inbound/GetTrackContacts")
      .then((data) => {
        // console.log(data);
        const trackTraceResult = data.data;
        if (trackTraceResult.length > 0) {
          trackTraceResult.map((res) => {
            res.CreatedOn = moment(res.CreatedOn).format("DD/MM/YYYY");
            console.log(res.CreatedOn);
            //   return contactResult;
          });
        }
        setTrackTrace(trackTraceResult);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }
  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Track & Trace Contacts</h2>
        {loading ? <Loader /> : null}
      </div>
      <Row>
        <Col md={12}>
          <div className="card pt-2">
            <div className="card-body">
              <div className="inventory-grid">
                <Fragment>
                  {trackTrace.length > 0 ? (
                    <ReactTable columns={columns} data={trackTrace} defaultPageSize={10} />
                  ) : (
                    <div className="no-data">No data found.</div>
                  )}
                </Fragment>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Footer />
    </section>
  );
};
export default TrackTrance;
